"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation sendRegistrationEmailCode($email: String!) {
    sendRegistrationEmailCode(email: $email)
  }
`;
exports.default = mutation;
//# sourceMappingURL=sendRegistrationEmailCode.mutation.js.map